import LoginViaIdentityPage from '@/views/login/LoginViaIdentityPage'

export default function Page() {
  return <LoginViaIdentityPage />
}
